import { GOOGLE_FONTS, useGoogleFonts } from '~/client/common/hooks/use-google-fonts.hook'
import { EventSpaceList } from '~/shared/event/event.types'
import React from 'react'
import defaultCoverImage from '~/assets/images/presentations/default/cover-image.png'
import revelstreetLogo from '~/assets/images/presentations/default/revelstreet-logo.svg'
import { formatUtcDateLongFromUnknown } from '~/shared/common/date'

const Container: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className="bg-[#d2c6bb] w-[1920px] h-[1080px] min-w-[1920px] min-h-[1080px] max-w-[1920px] max-h-[1080px] p-0 m-0 relative overflow-hidden flex flex-col">{children}</div>
)

interface NewDefaultSlideCoverProps {
  eventSpaceList: EventSpaceList
  coverImage?: string | null
}

const NewDefaultSlideCover: React.FC<NewDefaultSlideCoverProps> = ({ eventSpaceList, coverImage }) => {
  useGoogleFonts([GOOGLE_FONTS.LIBRE_BASKERVILLE])

  return (
    <Container>
      {/* Main Grid Layout with borders */}
      <div className="h-full grid grid-cols-[60px_1080px_60px_660px_60px] grid-rows-[60px_1fr_60px] border-black">
        {/* Top Border */}
        <div className="col-span-5 border-b border-black" />

        {/* Left Margin */}
        <div className="row-span-1 border-r border-black my-[-60px]" />

        {/* Left Content Area */}
        <div className="flex flex-col justify-between py-16 px-[44px]">
          {/* Event Name - centered vertically in available space */}
          <div className="flex-1 flex items-center text-left">
            <div className="font-['Libre_Baskerville',serif] text-[80px] font-normal leading-[75px]">{eventSpaceList.name}</div>
          </div>

          {/* Bottom section with Venue OPTIONS and Date */}
          <div className="flex justify-between">
            <div className="flex flex-col">
              <div className="font-['Libre_Baskerville',serif] text-[80px] font-normal text-[#8a3dff] leading-[75px]">Venue</div>
              <div className="font-['Libre_Baskerville',serif] text-[80px] font-bold text-[#8a3dff] leading-[75px]">OPTIONS</div>
            </div>

            {/* Date */}
            <div className="font-['Nunito_Sans',sans-serif] text-[30px] font-semibold text-black h-full flex items-end">
              {formatUtcDateLongFromUnknown(eventSpaceList?.event_space_list_dates?.[0]?.start_date, 'en-US') ?? ''}
            </div>
          </div>
        </div>

        {/* Center Vertical Border */}
        <div className="row-span-1 border-r border-black" />

        {/* Right Image Area */}
        <div className="overflow-hidden">
          <img src={coverImage || defaultCoverImage} alt="Cover" className="w-full h-full object-cover object-center" />
        </div>

        <div className="absolute bottom-[10px] right-[80px]">
          <img src={revelstreetLogo} alt="Revelstreet Logo" className="w-[280px] h-auto object-cover object-center" />
        </div>

        {/* Right Margin */}
        <div className="row-span-1 border-l border-black my-[-60px]" />

        {/* Bottom Border */}
        <div className="col-span-5 border-t border-black" />
      </div>
    </Container>
  )
}

export default NewDefaultSlideCover
